var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLgChevronRight = function SvgLgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "lg-chevron-right_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "lg-chevron-right_svg__lg-chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.38 21.01c.49.49 1.28.49 1.77 0l8.31-8.31a.996.996 0 0 0 0-1.41L9.15 2.98a1.25 1.25 0 0 0-1.77 0 1.25 1.25 0 0 0 0 1.77L14.62 12l-7.25 7.25c-.48.48-.48 1.28.01 1.76",
    className: "lg-chevron-right_svg__vector"
  }))));
};
export { SvgLgChevronRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIj48ZyBjbGFzcz0ibGctY2hldnJvbi1yaWdodCI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNNy4zOCAyMS4wMWMuNDkuNDkgMS4yOC40OSAxLjc3IDBsOC4zMS04LjMxYS45OTYuOTk2IDAgMCAwIDAtMS40MUw5LjE1IDIuOThhMS4yNSAxLjI1IDAgMCAwLTEuNzcgMCAxLjI1IDEuMjUgMCAwIDAgMCAxLjc3TDE0LjYyIDEybC03LjI1IDcuMjVjLS40OC40OC0uNDggMS4yOC4wMSAxLjc2WiIgY2xhc3M9InZlY3RvciIvPjwvZz48L3N2Zz4=";